import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_zMxVF811QQ0P: {
	id: 'prd_zMxVF2DEV2811QQ0P'
	ident: 'prd_zMxVF811QQ0P'
	sku: 'simple_premium_3m_15_99_3m_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'month'
			interval_duration: 3
			iteration_count: 1
			price_id: 'prc_mNtWm2DEV2bPeVsuT'
			amount: 79
			amount_usd: 15.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 15.99
			discount: 63.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'month'
			interval_duration: 3
			iteration_count: null
			price_id: 'prc_kiI9S2DEV2jaTek6o'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_zMxVF811QQ0P, SubscriptionProduct>
const prd_zMxVF811QQ0P = { ident: 'prd_zMxVF811QQ0P' } as typeof _prd_zMxVF811QQ0P

export default prd_zMxVF811QQ0P
